export const color = {
	primary: '#282B34',
	secondary: '#E7E9E7',
	tertiary: '#ffffff',
	headerLogo: '#282B34',

	blackOne: '#000',
	blackTwo: '#43484D',

	buttonNextBgColor: '#282B34',
	buttonNextTextColor: '#ffffff',
	buttonNextMobileColor: '#282B34',
	buttonNextMobileTextColor: '#000',
	buttonNextBorderColor: '#282B34',
	buttonNextMobileBorderColor: '#282B34',
	buttonNextHoverBgColor: '#ffffff',
	buttonNextHoverTextColor: '#282B34',
	buttonNextHoverBorderColor: '#282B34',

	buttonBackBgColor: '#ffffff',
	buttonBackTextColor: '#282B34',
	buttonBackMobileBgColor: '#282B34',
	buttonBackMobileTextColor: '#000',
	buttonBackBorderColor: '#282B34',
	buttonBackMobileBorderColor: '#282B34',
	buttonBackHoverBgColor: '#282B34',
	buttonBackHoverTextColor: '#fff',
	buttonBackHoverBorderColor: '#282B34',

	exchangeSelectBtnTextColor: '#ffffff',
	exchangeSelectBtnBgColor: '#282B34',
	exchangeSelectBtnBorderColor: '#282B34',
	exchangeSelectBtnBorderSize: '2px',
	exchangeSelectBtnSVGColor: '#ffffff',

	exchangeDontSelectBtnTextColor: '#ffffff',
	exchangeDontSelectBtnBgColor: '#000000',
	exchangeDontSelectBtnBorderColor: '#000000',
	exchangeDontSelectBtnBorderSize: '2px',
	exchangeDontSelectBtnSVGColor: '#ffffff',

	exchangeRemoveSelectBtnTextColor: '#ffffff',
	exchangeRemoveSelectBtnBgColor: '#000000',
	exchangeRemoveSelectBtnBorderColor: '#000000',
	exchangeRemoveSelectBtnBorderSize: '2px',
	exchangeRemoveSelectBtnSVGColor: '#ffffff',

	flowButtonSelectedTextColor: '#ffffff',
	flowButtonSelectedBgColor: '#282B34',
	flowButtonSelectedBorderColor: '#282B34',

	flowButtonOriginalTextColor: '#000000',
	flowButtonOriginalBgColor: '#ffffff',
	flowButtonOriginalBorderColor: '#000000',

	grayOne: '#E6E6E6',
	grayTwo: '#f7f7f7',
	grayThree: '#666',
	grayFour: '#C4C4C4',
	grayFive: '#DCDCDC',
	graySix: '#A6A6A6',
	graySeven: '#F1F1F1',
	grayEight: '#F5F5F5',
	grayTen: '#666666',
	grayEleven: '#EDEDED',
	grayTwelve: '#E6E6E6',
	grayThirteen: '#DADADA',
	grayFourteen: '#696969',
	grayFifteen: '#E5E5E5',
	graySixteen: '#E2E2E2',
	graySeventeen: '#D3D3D3',
	grayEighteen: '#5E5E5E',
	grayNineteen: '#A1A1A1',

	greenTwo: '#D7F2EA',
	greenThree: '#D7F2EA',
	greenFour: 'rgba(45,205,178,0.2)',

	redOne: '#EA0000',
	redTwo: '#F32727',
}
